import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";
import { withNamespaces } from "react-i18next";

import { connect } from "react-redux";

const Navbar = (props) => {
  const [procurement, setProcurement] = useState(false);
  const [procurement_CentreRequisitions, setProcurement_CentreRequisitions] =
    useState(false);

  const [centreInventory, setCentreInventory] = useState(false);
  const [centralStore_ItemInventory, setCentralStore_ItemInventory] =
    useState(false);
  const [centralStore_BranchInventory, setCentralStore_BranchInventory] =
    useState(false);
  const [centreInventory_ItemOrder, setCentreInventory_ItemOrder] =
    useState(false);
  const [centralKitchen, setCentralKitchen] = useState(false);
  const [centralKitchen_FPOrder, setCentralKitchen_FPOrder] = useState(false);
  const [centralKitchen_FPInventory, setCentralKitchen_FPInventory] =
    useState(false);
  const [masterData, setMasterData] = useState(false);
  const [master_Item, setMaster_Item] = useState(false);
  const [master_Item_Items, setMaster_Item_Items] = useState(false);
  const [master_Item_ItemCategories, setMaster_Item_ItemCategories] =
    useState(false);
  const [master_Products, setMaster_Products] = useState(false);
  const [master_Products_Products, setMaster_Products_Products] =
    useState(false);
  const [
    master_Products_ProductCategories,
    setMaster_Products_ProductCategories,
  ] = useState(false);
  const [master_Supplier, setMaster_Supplier] = useState(false);

  const [users, setUsers] = useState(false);
  const [branchOrders, setBranchOrders] = useState(false);
  const [branchOrders_FinishedProducts, setBranchOrders_FinishedProducts] =
    useState(false);
  const [branchOrders_Items, setBranchOrders_Items] = useState(false);
  const [branchInventory, setBranchInventory] = useState(false);
  const [transferItems, setTransferItems] = useState(false);
  const [order_For_SM, setOrder_For_SM] = useState(false);
  const [returnItems, setReturnItems] = useState(false);
  const [branchTransferInventory, setBranchTransferInventory] = useState(false);
  const [
    branchTransfers_FinishedProducts,
    setBranchTransfers_FinishedProducts,
  ] = useState(false);
  const [branchTransfers_Items, setBranchTransfers_Items] = useState(false);

  const [branchClosing, setBranchClosing] = useState(false);
  const [uom_Masters, setUom_Masters] = useState(false);
  const [store_Master, setStore_Master] = useState(false);
  const [locationMaster, setLocationMaster] = useState(false);
  const [vehicleMaster, setVehicleMaster] = useState(false);
  const [centralKitchenStore, setCentralKitchenStore] = useState(false);
  const [store_Item_Order, setStore_Item__order] = useState(false);
  const [equipment_Master, setEquipment_Master] = useState(false);
  const [equipment_Category_Master, setEquipment_Category_Master] = useState(false);
  const [poRequestForCK, setPoRequestForCK] = useState(false);
  const [allPOForCK, setAllPOForCK] = useState(false);
  const [equipmentStore, setEequipmentStore] = useState(false);
  const [equipmentOrders, setEquipmentOrders] = useState(false);
  const [equipmentInventory, setEquipmentInventory] = useState(false);
  const [directTransfer, setDirectTransfer] = useState(false);
  const [correction, setCorrection] = useState(false)
  const [correctionOrders, setCorrectionOrders] = useState(false)
  const [correctionWithdrawl, setCorrectionWithdrawl] = useState(false)

  useEffect(() => {
    const root = document.getElementById("navigation");
    if (!root) return;

    const current =
      ((props.location && props.location.pathname) || "").replace(/\/+$/, "") ||
      "/";

    root.querySelectorAll(".menu-current, .menu-current-parent").forEach((el) => {
      el.classList.remove("menu-current", "menu-current-parent");
    });

    root.querySelectorAll("a[href]").forEach((link) => {
      const href = link.getAttribute("href") || "";
      if (href === "/#" || href === "#" || href === "/") return;
      const path = (link.pathname || "").replace(/\/+$/, "") || "/";
      if (path !== current) return;

      link.classList.add("menu-current");
      let parent = link.parentElement;
      while (parent && parent !== root) {
        if (
          parent.classList &&
          (parent.classList.contains("dropdown") ||
            parent.classList.contains("nav-item"))
        ) {
          const toggle = parent.querySelector(":scope > a");
          if (toggle && toggle !== link) {
            toggle.classList.add("menu-current-parent");
          }
        }
        parent = parent.parentElement;
      }
    });
  });

  const role = localStorage.getItem("role");
  const is_store = localStorage.getItem("is_store");
  const store_type = localStorage.getItem("store_type");
  const transfer_privilege = localStorage.getItem("transfer_privilege");
  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
              {/* Dashboard  */}
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle arrow-none" to="/dashboard">
                    <i className="bx bx-home-circle mr-2"></i>
                    {props.t("Dashboard")}
                  </Link>
                </li>

                {/* Procure.  for Bransh supervisors */}
                {(role === "Branch Supervisor") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setProcurement(!procurement);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-receipt mr-2"></i>
                        {props.t("Procure.")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: procurement,
                        })}
                      >
                        <Link
                          to="/branch_requisition_request"
                          className="dropdown-item"
                        >
                          {props.t("New PO Request")}
                        </Link>
                        <Link to="/branch_po_requests" className="dropdown-item">
                          {props.t("All PO Requests")}
                        </Link>
                        <Link to="/branch_all_po" className="dropdown-item">
                          {props.t("All Purchase Orders")}
                        </Link>
                      </div>
                    </li>
                  )}

                {/* Procure.  for Bransh CKM */}
                {(role === "Central Kitchen Manager") && (
                    <>
                        <li className="nav-item dropdown">
  <Link
    to="/#"
    onClick={(e) => {
      e.preventDefault();
      setProcurement(!procurement);
    }}
    className="nav-link dropdown-toggle arrow-none"
  >
    <i className="bx bx-receipt mr-2"></i>
    {props.t("Procure.")}
    <div className="arrow-down"></div>
  </Link>

  <div
    className={classname("dropdown-menu", { show: procurement })}
  >
    {/* Generate FP PO */}
    <Link to="/finished_product/generate_po" className="dropdown-item">
      {props.t("Generate FP PO")}
    </Link>

    {/* PO Request Submenu */}
    <div className="dropdown">
      <Link
        to="/#"
        onClick={(e) => {
          e.preventDefault();
          setPoRequestForCK(!poRequestForCK);
        }}
        className="dropdown-item dropdown-toggle arrow-none"
      >
        {props.t("PO Request")}
        <div className="arrow-down"></div>
      </Link>
      <div
        className={classname("dropdown-menu", { show: poRequestForCK })}
      >
        <Link
          to="/branch_requisition_request"
          className="dropdown-item"
        >
          {props.t("New PO Request")}
        </Link>
        <Link
          to="/branch_po_requests"
          className="dropdown-item"
        >
          {props.t("All PO Requests")}
        </Link>
      </div>
    </div>

    {/* All Purchase Orders Submenu */}
    <div className="dropdown">
      <Link
        to="/#"
        onClick={(e) => {
          e.preventDefault();
          setAllPOForCK(!allPOForCK);
        }}
        className="dropdown-item dropdown-toggle arrow-none"
      >
        {props.t("All Purchase Orders")}
        <div className="arrow-down"></div>
      </Link>
      <div
        className={classname("dropdown-menu", { show: allPOForCK })}
      >
        <Link
          to="/branch_all_po"
          className="dropdown-item"
        >
          {props.t("Item")}
        </Link>
        <Link
          to="/finished_product/all_po"
          className="dropdown-item"
        >
          {props.t("Finished Product")}
        </Link>
      </div>
    </div>
  </div>
</li>

                        </>
               
                  )}

                  {/* Equipment Store */}
                {role === "Equipment Store Manager" && (
                  <>
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setEequipmentStore(!equipmentStore);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-store mr-2"></i>
                        {props.t("Equipment Store")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: equipmentStore,
                        })}
                      >
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setStore_Item__order(!store_Item_Order);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Order")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: store_Item_Order,
                            })}
                          >
                            <Link
                              to="/equipments/new_orders"
                              className="dropdown-item"
                            >
                              {props.t("New Orders")}
                            </Link>
                            <Link
                              to="/equipments/orders_in_process"
                              className="dropdown-item"
                            >
                              {props.t("Orders in Process")}
                            </Link>
                            <Link
                              to="/equipments/closed_orders"
                              className="dropdown-item"
                            >
                              {props.t("Closed Orders")}
                            </Link>
                            {/* <Link
                              to="/equipments/all_orders"
                              className="dropdown-item"
                            >
                              {props.t("Orders List")}
                            </Link> */}
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setEquipmentInventory(!equipmentInventory);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Inventory")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: equipmentInventory,
                            })}
                          >
                            <Link
                              to="/equipments/update_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Add Inventory")}
                            </Link>
                            <Link
                              to="/equipments/view_inventory_store"
                              className="dropdown-item"
                            >
                              {props.t("View Inventory")}
                            </Link>
                            <Link
                              to="/equipments/view_branch_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Branch Inventory")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  </>
                )}

                {/* Procurement */}
                {(role === "admin" ||
                  role === "Operations Manager" ||
                  role === "Client Admin" ||
                  role === "Central Store Manager") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setProcurement(!procurement);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-receipt mr-2"></i>
                        {props.t("Procurement")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: procurement,
                        })}
                      >
                        {/* <Link to="/add_requisition" className="dropdown-item">
                        {props.t("Add Requisition")}
                      </Link> */}
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setProcurement_CentreRequisitions(
                                !procurement_CentreRequisitions
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Generate PO")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: procurement_CentreRequisitions,
                            })}
                          >
                            <Link
                              to="/branchwise_requisition"
                              className="dropdown-item"
                            >
                              {props.t("Branch-wise")}
                            </Link>
                            <Link
                              to="/mainstorewise_requisition"
                              className="dropdown-item"
                            >
                              {props.t("Main Store-wise")}
                            </Link>
                            <Link
                              to="/substorewise_requisition"
                              className="dropdown-item"
                            >
                              {props.t("Sub Store-wise")}
                            </Link>
                            <Link
                              to="/supplierwise_requisition"
                              className="dropdown-item"
                            >
                              {props.t("Supplier-wise")}
                            </Link>
                          </div>
                        </div>
                        <Link to="/branch_po_requests" className="dropdown-item">
                          {props.t("Branch PO Requests")}
                        </Link>
                        <Link
                          to="/mainstore_po_requests"
                          className="dropdown-item"
                        >
                          {props.t("Main Store PO Requests")}
                        </Link>
                        <Link
                          to="/substore_po_requests"
                          className="dropdown-item"
                        >
                          {props.t("Sub Store PO Requests")}
                        </Link>
                        <Link to="/all_po" className="dropdown-item">
                          {props.t("All Purchase Orders")}
                        </Link>
                      </div>
                    </li>
                  )}

{/* Procurement */}
{(role === "Central Store Assistant" ||
                  role === "Storekeeper") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setProcurement(!procurement);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-receipt mr-2"></i>
                        {props.t("Procurement")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: procurement,
                        })}
                      >
                        <Link to="/create_draft" className="dropdown-item">
                          {props.t("Create Draft")}
                        </Link>
                        <Link to="/branch_po_requests" className="dropdown-item">
                          {props.t("Branch PO Requests")}
                        </Link>
                        <Link
                          to="/mainstore_po_requests"
                          className="dropdown-item"
                        >
                          {props.t("Main Store PO Requests")}
                        </Link>
                        <Link
                          to="/substore_po_requests"
                          className="dropdown-item"
                        >
                          {props.t("Sub Store PO Requests")}
                        </Link>
                        <Link to="/all_po" className="dropdown-item">
                          {props.t("All Purchase Orders")}
                        </Link>
                      </div>
                    </li>
                  )}

                  {/* Orders  */}
                  {(role === "Central Store Manager"||role === "Storekeeper") && (
                    <>
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setOrder_For_SM(!order_For_SM);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart mr-2"></i>
                        {props.t("Orders")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: order_For_SM,
                        })}
                      >
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setBranchOrders_Items(!branchOrders_Items);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Items")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: branchOrders_Items,
                            })}
                          >
                            <Link
                              to="/items/add_new_order/from/central"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>

                            {role === "Central Store Manager" && (
                              <Link
                              to="/items/centre/all_item_orders"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                            )}
                          </div>
                        </div>
                        {role === "Storekeeper" && (
                          <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setTransferItems(!transferItems);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Transfer")} <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: transferItems,
                            })}
                          >
                           <Link
                          to="/items/transfer/from/central"
                          className="dropdown-item"
                        >
                          {props.t("Item Transfer")}
                        </Link>
                        <Link
                          to="/items/alltransfers"
                          className="dropdown-item"
                        >
                          {props.t("All Transfers")}
                        </Link>

                        <Link
                          to="/items/centre/all_item_requests"
                          className="dropdown-item"
                        >
                          {props.t("All Requests")}
                        </Link>
                          </div>
                        </div>
                        )}

                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setReturnItems(!returnItems);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Return Items")} <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: returnItems,
                            })}
                          >
                            <Link to="/centralstore/items/return" className="dropdown-item">
                              {props.t("New Return")}
                            </Link>
                            <Link
                              to="/centralstore/items/allreturn"
                              className="dropdown-item"
                            >
                              {props.t("All Returns")}
                            </Link>
                          </div>
                        </div>

                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setEquipmentOrders(!equipmentOrders);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Equipments")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: equipmentOrders,
                            })}
                          >
                            <Link
                              to="/equipments/add_orders/central"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>
                            {role === "Central Store Manager" && (
                              <Link
                              to="/equipments/all_orders/central"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                            )}
                            
                          </div>
                        </div>
                      </div>
                    </li>

                    </>
                  )}
                  {/* Transfers  */}
                    {(role==="Central Store Manager") && (
                      <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setTransferItems(!transferItems);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-swap-horizontal mr-2"></i>
                        {props.t("Transfer")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: transferItems,
                        })}
                      >
                        <Link
                          to="/items/transfer/from/central"
                          className="dropdown-item"
                        >
                          {props.t("Item Transfer")}
                        </Link>
                        <Link
                          to="/items/alltransfers"
                          className="dropdown-item"
                        >
                          {props.t("All Transfers")}
                        </Link>

                        <Link
                          to="/items/centre/all_item_requests"
                          className="dropdown-item"
                        >
                          {props.t("All Requests")}
                        </Link>
                      </div>
                    </li>
                    )}


                {/* Purchase Order Approvals */}
                {role === "Owner" && (
                  <li className="nav-item dropdown">
                    <Link
                      to="/all_po_owner"
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="bx bx-receipt mr-2"></i>
                      {props.t("Purchase Order Approvals")}
                    </Link>
                  </li>
                )}

                {/* Central Store */}
                {(role === "admin" ||
                  role === "Operations Manager" ||
                  role === "Client Admin" ||
                  role === "Storekeeper" ||
                  role === "Central Store Manager") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setCentreInventory(!centreInventory);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart-plus mr-2"></i>
                        {props.t("Central Store")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: centreInventory,
                        })}
                      >
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCentreInventory_ItemOrder(
                                !centreInventory_ItemOrder
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Item Order")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: centreInventory_ItemOrder,
                            })}
                          >
                            {/* <Link
                              to="/items/new_orders"
                              className="dropdown-item"
                            >
                              {props.t("New Orders")}
                            </Link> */}
                            <Link
                              to="/items/orders_in_process"
                              className="dropdown-item"
                            >
                              {props.t("Orders in Process")}
                            </Link>
                            {/* <Link
                              to="/items/edit_orders"
                              className="dropdown-item"
                            >
                              {props.t("Edit Orders")}
                            </Link> */}
                            <Link
                              to="/items/closed_orders"
                              className="dropdown-item"
                            >
                              {props.t("Closed Orders")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCentralStore_ItemInventory(
                                !centralStore_ItemInventory
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Item Inventory")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: centralStore_ItemInventory,
                            })}
                          >
                            {/* {role === "admin" && (
                              <Link
                                to="/items/update_inventory"
                                className="dropdown-item"
                              >
                                {props.t("Add Inventory")}
                              </Link>
                            )} */}

                            <Link
                              to="/items/view_inventory"
                              className="dropdown-item"
                            >
                              {props.t("View Inventory")}
                            </Link>
                            <Link
                              to="/items/used_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Used Inventory")}
                            </Link>
                            {/* <Link to="/#" className="dropdown-item">
                            {props.t("View Items Branch-wise")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Expired Items")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("View Items Below Threshold")}
                          </Link> */}
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCentralStore_BranchInventory(
                                !centralStore_BranchInventory
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Branch Inventory")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: centralStore_BranchInventory,
                            })}
                          >
                            <Link
                              to="/items/view_branchwise_inventory"
                              className="dropdown-item"
                            >
                              {props.t("View Inventory")}
                            </Link>
                            <Link
                              to="/items/transfer_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Transfer Inventory")}
                            </Link>
                          </div>
                        </div>
                        <Link
                          to="/equipments/central/inventory"
                          className="dropdown-item"
                        >
                          {props.t("Equip. Inventory")}
                        </Link>
                      </div>
                    </li>
                  )}

                {/* Central Store */}
                {role === "Central Store Assistant" && (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        setCentreInventory(!centreInventory);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="mdi mdi-cart-plus mr-2"></i>
                      {props.t("Central Store")}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: centreInventory,
                      })}
                    >
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setCentreInventory_ItemOrder(
                              !centreInventory_ItemOrder
                            );
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Item Order")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: centreInventory_ItemOrder,
                          })}
                        >
                          {/* <Link
                            to="/items/new_orders"
                            className="dropdown-item"
                          >
                            {props.t("New Orders")}
                          </Link> */}
                          <Link
                            to="/items/orders_in_process"
                            className="dropdown-item"
                          >
                            {props.t("Orders in Process")}
                          </Link>
                          {/* <Link
                            to="/items/edit_order"
                            className="dropdown-item"
                          >
                            {props.t("Edit Orders")}
                          </Link> */}
                          <Link
                            to="/items/closed_orders"
                            className="dropdown-item"
                          >
                            {props.t("Closed Orders")}
                          </Link>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setCentralStore_ItemInventory(
                              !centralStore_ItemInventory
                            );
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Item Inventory")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: centralStore_ItemInventory,
                          })}
                        >
                          <Link
                            to="/items/update_inventory"
                            className="dropdown-item"
                          >
                            {props.t("Add Inventory")}
                          </Link>
                          <Link
                            to="/items/view_inventory"
                            className="dropdown-item"
                          >
                            {props.t("View Inventory")}
                          </Link>

                          {/* <Link to="/#" className="dropdown-item">
                            {props.t("View Items Branch-wise")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Expired Items")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("View Items Below Threshold")}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </li>
                )}

                {/* Central Kitchen */}
                {(role === "admin" ||
                  role === "Storekeeper" ||
                  role === "Operations Manager" ||
                  role === "Client Admin" || 
                  role === "Central Kitchen Manager") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setCentralKitchen(!centralKitchen);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-store mr-2"></i>
                        {props.t("Central Kitchen")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: centralKitchen,
                        })}
                      >
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCentralKitchen_FPOrder(!centralKitchen_FPOrder);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("FP Order")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: centralKitchen_FPOrder,
                            })}
                          >
                            <Link
                              to="/finished_products/new_orders"
                              className="dropdown-item"
                            >
                              {props.t("New Orders")}
                            </Link>
                            <Link
                              to="/finished_products/orders_in_process"
                              className="dropdown-item"
                            >
                              {props.t("Orders in Process")}
                            </Link>
                            <Link
                              to="/finished_products/closed_orders"
                              className="dropdown-item"
                            >
                              {props.t("Closed Orders")}
                            </Link>
                            <Link
                              to="/finished_products/all_orders_new"
                              className="dropdown-item"
                            >
                              {props.t("Orders List")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCentralKitchen_FPInventory(
                                !centralKitchen_FPInventory
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("FP Inventory")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: centralKitchen_FPInventory,
                            })}
                          >
                            <Link
                              to="/finished_products/update_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Add Inventory")}
                            </Link>
                            <Link
                              to="/finished_products/view_inventory"
                              className="dropdown-item"
                            >
                              {props.t("View Inventory")}
                            </Link>
                            {/* <Link to="/#" className="dropdown-item">
                            {props.t("View FP Branch-wise")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Expired Products")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("View Products Below Threshold")}
                          </Link> */}
                          </div>
                        </div>
                        <Link
                          to="/equipments/centralkitchen/inventory"
                          className="dropdown-item"
                        >
                          {props.t("Equip. Inventory")}
                        </Link>
                        {/* <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setCentralKitchen_BranchInventory(
                              !centralKitchen_BranchInventory
                            );
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Branch Inventory")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: centralKitchen_BranchInventory,
                          })}
                        >
                          <Link
                            to="/finished_products/view_branchwise_inventory"
                            className="dropdown-item"
                          >
                            {props.t("View Inventory")}
                          </Link>
                          <Link
                            to="/finished_products/transfer_inventory"
                            className="dropdown-item"
                          >
                            {props.t("Transfer Inventory")}
                          </Link>
                        </div>
                      </div> */}
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setBranchTransfers_FinishedProducts(
                                !branchTransfers_FinishedProducts
                              );
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Branch Inventory")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: branchTransfers_FinishedProducts,
                            })}
                          >

                            {/* <Link
                            to="/finished_products/transfer_inventory"
                            className="dropdown-item"
                          >
                            {props.t("All Transfers")}
                          </Link> */}
                            <Link
                              // to="/finished_products/view_all_branch_inventory"
                              to="/finished_products/view_branchwise_inventory"
                              className="dropdown-item"
                            >
                              {props.t("View Inventory")}
                            </Link>
                            <Link
                              to="/finished_products/transfer_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Transfer Inventory")}
                            </Link>
                          </div>
                        </div>
                        {/* <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchTransfers_Items(!branchTransfers_Items);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Branch Items Trans.")}{" "}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchTransfers_Items,
                          })}
                        >
                          <Link
                            to="/items/transfer_inventory_by_branch"
                            className="dropdown-item"
                          >
                            {props.t("New Transfer")}
                          </Link>
                          <Link
                            to="/items/transfer_inventory"
                            className="dropdown-item"
                          >
                            {props.t("All Transfers")}
                          </Link>
                          <Link
                            to="/items/view_all_branch_inventory"
                            className="dropdown-item"
                          >
                            {props.t("Branch Inventory")}
                          </Link>
                        </div>
                      </div> */}

                        {/* <Link
                        to="/finished_products/view_branch_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Finished Products")}
                      </Link> */}
                        <Link
                          to="/finished_products/view_branch_inventory_kitchen"
                          className="dropdown-item"
                        >
                          {props.t("Used Finished Products")}
                        </Link>
                        {/* <Link
                        to="/finished_products/expired_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Expired Products")}
                      </Link>  */}
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setDirectTransfer(!directTransfer);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Direct Transfer")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: directTransfer,
                            })}
                          >

                            <Link
                              to="/finished_products/direct_transfer"
                              className="dropdown-item"
                            >
                              {props.t("Transfer Products")}
                            </Link>
                            <Link
                              to="/finished_products/alltransfers"
                              className="dropdown-item"
                            >
                              {props.t("All Transfers")}
                            </Link>
                          </div>
                        </div>
                        <Link
                          to="/items/view_branch_inventory"
                          className="dropdown-item"
                        >
                          {props.t("Items")}
                        </Link>
                       {role !=="Storekeeper" && (
                         <Link
                         to="/items/alltransfers"
                         className="dropdown-item"
                       >
                         {props.t("All Item Transfers")}
                       </Link>
                       )}
                        <Link
                          to="/items/view_branch_inventory_kitchen"
                          className="dropdown-item"
                        >
                          {props.t("Used Items")}
                        </Link>
                        <Link
                          to="/items/expired_inventory"
                          className="dropdown-item"
                        >
                          {props.t("Expired Items")}
                        </Link>
                        {role === "Storekeeper" &&(
                          <>
                          <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setBranchClosing(!branchClosing);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Closing")}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: branchClosing,
                            })}
                          >
                             <Link
                          to="/closing/finished_products"
                          className="dropdown-item"
                        >
                          {props.t("Finished Products")}
                        </Link>
                        <Link to="/closing/items" className="dropdown-item">
                          {props.t("Items")}
                        </Link>
                          </div>
                        </div>
                        </>
                        )}
                      </div>
                    </li>
                  )}

{/* Central Kitchen Store */}
{(role==="Central Kitchen Manager" ||  role==="Storekeeper") && (
  <>
  <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setCentralKitchenStore(!centralKitchenStore);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart mr-2"></i>
                        {props.t("Central Kitchen Store")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: centralKitchenStore,
                        })}
                      >
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setStore_Item__order(!store_Item_Order);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Items")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: store_Item_Order,
                            })}
                          >
                            <Link
                              to="/items/add_order"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>
                            <Link
                              to="/items/all_orders"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                            <Link
                              to="/items/alldrafts"
                              className="dropdown-item"
                            >
                              {props.t("All Draft's")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setReturnItems(!returnItems);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Return Items")} <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: returnItems,
                            })}
                          >
                            <Link to="/branch/items/return" className="dropdown-item">
                              {props.t("New Return")}
                            </Link>
                            <Link
                              to="/branch/items/allreturn"
                              className="dropdown-item"
                            >
                              {props.t("All Returns")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setEquipmentOrders(!equipmentOrders);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Equipments")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: equipmentOrders,
                            })}
                          >
                            <Link
                              to="/equipments/add_orders/centralkitchen"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>
                            <Link
                              to="/equipments/all_orders/centralkitchen"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
  </>
)}
                {/*  Closing */}
                {role === "Central Kitchen Manager" && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setBranchClosing(!branchClosing);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart-plus mr-2"></i>
                        {props.t("Closing")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: branchClosing,
                        })}
                      >
                        <Link
                          to="/closing/finished_products"
                          className="dropdown-item"
                        >
                          {props.t("Finished Products")}
                        </Link>
                        <Link to="/closing/items" className="dropdown-item">
                          {props.t("Items")}
                        </Link>
                      </div>
                    </li>
                )}

                {/* Corrections  */}
                {(role === "admin" || role === "Client Admin") && (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        setCorrection(!correction);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="mdi mdi-check-circle mr-2"></i>
                      {props.t("Correction")}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: correction,
                      })}
                    >
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setCorrectionOrders(!correctionOrders);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Orders")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div className={classname("dropdown-menu", { show: correctionOrders })}>
                          <Link to="/item_order_correction" className="dropdown-item" >
                            {props.t("Item Orders")}
                          </Link>
                          <Link to="/finished_poduct_order_correction" className="dropdown-item" >
                            {props.t("FP Orders")}
                          </Link>
                        </div>
                      </div>

                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setCorrectionWithdrawl(!correctionWithdrawl);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Withdrawals")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div className={classname("dropdown-menu", { show: correctionWithdrawl })}>
                          <Link to="/item_withdrawl_correction" className="dropdown-item" >
                            {props.t("Item")}
                          </Link>
                          <Link to="/finished_product_withdrawl_correction" className="dropdown-item" >
                            {props.t("Finished Product")}
                          </Link>
                        </div>
                      </div>

                      <Link to="/purchase_order_correction" className="dropdown-item">
                        {props.t("Purchase Orders")}
                      </Link>
                    </div>
                  </li>
                )}

                {/* Master Data  */}
                {(role === "admin" ||
                  role === "Central Store Assistant" ||
                  role === "Operations Manager" ||
                  role === "Client Admin" || 
                  role === "Storekeeper" || 
                  role === "Central Store Manager" ||
                  role === "Equipment Store Manager" ||
                  role === "Central Kitchen Manager") && (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setMasterData(!masterData);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-book mr-2"></i>
                        {props.t("Master Data")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: masterData,
                        })}
                      >

                        {(role === "admin" ||
                          role === "Operations Manager" ||
                          role === "Client Admin" ||
                          role === "Storekeeper" ||
                          role === "Central Kitchen Manager" ||
                          role === "Central Store Assistant" ||
                          role === "Central Store Manager") && (
                            <div className="dropdown">
                              <Link
                                to="/#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setStore_Master(!store_Master);
                                }}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Store/Branch")}
                                <div className="arrow-down"></div>
                              </Link>
                              <div
                                className={classname("dropdown-menu", {
                                  show: store_Master,
                                })}
                              >
                                {(role === "admin" ||
                                role === "Client Admin" ||
                                  role === "Operations Manager") && (
                                    <>
                                      <Link to="/add_store" className="dropdown-item">
                                        {props.t("Add Store/Branch")}
                                      </Link>
                                      <Link
                                        to="/update_store"
                                        className="dropdown-item"
                                      >
                                        {props.t("View/Update Store/Branch")}
                                      </Link>
                                        <Link to="/branch_category" className="dropdown-item">
                                        {props.t("Branch Category")}
                                      </Link>
                                    </>
                                  )}

                                {(role === "admin" ||
                                  role === "Central Store Assistant" ||
                                  role === "Operations Manager" ||
                                  role === "Client Admin" ||
                                  role === "Storekeeper" ||
                                  role === "Central Store Manager") && (
                                    <>
                                      <Link
                                        to="/mainstore_items"
                                        className="dropdown-item"
                                      >
                                        {props.t("Main Store - Items")}
                                      </Link>
                                      <Link
                                        to="/branch_items"
                                        className="dropdown-item"
                                      >
                                        {props.t("Branch Items - Sub Store")}
                                      </Link>
                                      <Link to="/items/map_to_all" className="dropdown-item">
                                        {props.t("Item - Branches Map/Unmap")}
                                      </Link>
                                    </>
                                  )}
                                {(role === "admin" ||
                                  role === "Operations Manager" ||
                                  role === "Client Admin" ||
                                  role === "Storekeeper" ||
                                  role === "Central Store Manager" ||
                                  role === "Central Kitchen Manager") && (
                                    <>
                                    <Link to="/branch_products" className="dropdown-item" >
                                      {props.t("Branch Products")}
                                    </Link>
                                     <Link to="/products/map_to_all" className="dropdown-item">
                                     {props.t("Product - Branches Map/Unmap")}
                                   </Link>
                                   </>
                                  )}
                              </div>
                            </div>
                          )}
                        {/* Items  */}
                        {(role === "admin" ||
                          role === "Operations Manager" ||
                          role === "Client Admin" ||
                          role === "Central Store Manager") && (
                            <div className="dropdown">
                              <Link
                                to="/#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMaster_Item(!master_Item);
                                }}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Item")} <div className="arrow-down"></div>
                              </Link>
                              <div
                                className={classname("dropdown-menu", {
                                  show: master_Item,
                                })}
                              >
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setMaster_Item_Items(!master_Item_Items);
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Items")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: master_Item_Items,
                                    })}
                                  >
                                    <Link to="/add_item" className="dropdown-item">
                                      {props.t("Add Item")}
                                    </Link>
                                    <Link to="/all_items" className="dropdown-item">
                                      {props.t("View/Update Item")}
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setMaster_Item_ItemCategories(
                                        !master_Item_ItemCategories
                                      );
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Item Categories")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: master_Item_ItemCategories,
                                    })}
                                  >
                                    <Link
                                      to="/item_categories"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add New Item Category")}
                                    </Link>
                                    <Link
                                      to="/categories-update"
                                      className="dropdown-item"
                                    >
                                      {props.t("View/Update Item Categories")}
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setUom_Masters(!uom_Masters);
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("UOM")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: uom_Masters,
                                    })}
                                  >
                                    <Link
                                      to="/add_item_uom"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Item UOM")}
                                    </Link>
                                    {role === "Central Kitchen Manager" && (
                                      <Link
                                        to="/add_product_uom"
                                        className="dropdown-item"
                                      >
                                        {props.t("Add Product UOM")}
                                      </Link>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {/* Finished Product  */}
                        {(role === "admin" ||
                          role === "Operations Manager" || 
                          role === "Client Admin" ||
                          role === "Central Kitchen Manager") && (
                            <div className="dropdown">
                              <Link
                                to="/#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMaster_Products(!master_Products);
                                }}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Finished Products")}
                                <div className="arrow-down"></div>
                              </Link>
                              <div
                                className={classname("dropdown-menu", {
                                  show: master_Products,
                                })}
                              >
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setMaster_Products_Products(
                                        !master_Products_Products
                                      );
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Products")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: master_Products_Products,
                                    })}
                                  >
                                    <Link
                                      to="/add_product"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Product")}
                                    </Link>
                                    <Link
                                      to="/add_product_uom"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Product UOM")}
                                    </Link>
                                    <Link
                                      to="/all_products"
                                      className="dropdown-item"
                                    >
                                      {props.t("View/Update Products")}
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setMaster_Products_ProductCategories(
                                        !master_Products_ProductCategories
                                      );
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Product Sections")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: master_Products_ProductCategories,
                                    })}
                                  >
                                    <Link
                                      to="/add_product_category"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Product Section")}
                                    </Link>
                                    <Link
                                      to="/product_categories"
                                      className="dropdown-item"
                                    >
                                      {props.t("View/Update Product Sections")}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {/* Equipment */}
                        {(role === "admin" ||
                          role === "Equipment Store Manager") && (
                            // <div className="dropdown">
                            //   <Link
                            //     to="/#"
                            //     onClick={(e) => {
                            //       e.preventDefault();
                            //       setMaster_Item(!master_Item);
                            //     }}
                            //     className="dropdown-item dropdown-toggle arrow-none"
                            //   >
                            //     {props.t("Equipment")}{" "}
                            //     <div className="arrow-down"></div>
                            //   </Link>
                            //   <div
                            //     className={classname("dropdown-menu", {
                            //       show: master_Item,
                            //     })}
                            //   >
                            <>
                                <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEquipment_Master(!equipment_Master);
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Equipments")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: master_Item_Items,
                                    })}
                                  >
                                    <Link
                                      to="/add_equipment"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Equipment")}
                                    </Link>
                                    <Link
                                      to="/update_equipment"
                                      className="dropdown-item"
                                    >
                                      {props.t("View/Update Equipment")}
                                    </Link>
                                  </div>
                                </div>
 <div className="dropdown">
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to="/#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEquipment_Category_Master(!equipment_Category_Master);
                                    }}
                                  >
                                    <span key="t-email-templates">
                                      {props.t("Equipments Category")}
                                    </span>
                                    <div className="arrow-down"></div>
                                  </Link>
                                  <div
                                    className={classname("dropdown-menu", {
                                      show: equipment_Master,
                                    })}
                                  >
                                    <Link
                                      to="/add_equipment_category"
                                      className="dropdown-item"
                                    >
                                      {props.t("Add Category")}
                                    </Link>
                                    <Link
                                      to="/update_equipment_category"
                                      className="dropdown-item"
                                    >
                                      {props.t("View/Update Category")}
                                    </Link>
                                  </div>
                                </div>
                                 <Link to="/add_equipment_unit" className="dropdown-item">
                                    {props.t("Equipments UOM")}
                                  </Link>
                                </>
                               
                            //   </div>
                            // </div>
                          )}
                        {/* Location and Driver  */}
                        {(role === "admin" ||
                          role === "Operations Manager" ||
                          role === "Client Admin" ||
                          role === "Central Store Assistant" ||
                          role === "Central Store Manager") && (
                            <>
                              <div className="dropdown">
                                <Link
                                  to="/#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setLocationMaster(!locationMaster);
                                  }}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Location")}
                                  <div className="arrow-down"></div>
                                </Link>
                                <div
                                  className={classname("dropdown-menu", {
                                    show: locationMaster,
                                  })}
                                >
                                  <>
                                    <Link to="/add_location" className="dropdown-item">
                                      {props.t("Add Location")}
                                    </Link>
                                    <Link to="/all_locations" className="dropdown-item">
                                      {props.t("View/Update Location")}
                                    </Link>
                                  </>
                                </div>
                              </div>
                              <div className="dropdown">
                                <Link
                                  to="/#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setVehicleMaster(!vehicleMaster);
                                  }}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Vehicle/Driver")}
                                  <div className="arrow-down"></div>
                                </Link>
                                <div
                                  className={classname("dropdown-menu", {
                                    show: vehicleMaster,
                                  })}
                                >
                                  <>
                                    <Link to="/add_vehicle" className="dropdown-item">
                                      {props.t("Add Vehicle/Driver")}
                                    </Link>
                                    <Link to="/all_vehicles" className="dropdown-item">
                                      {props.t("View/Update Veh./Dr.")}
                                    </Link>
                                  </>
                                </div>
                              </div>
                            </>
                          )}
                        {/* Supplier  */}
                        {(role === "admin" ||
                          role === "Operations Manager" ||
                          role === "Client Admin" ||
                          role === "Central Store Manager") && (
                            <div className="dropdown">
                              <Link
                                to="/#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMaster_Supplier(!master_Supplier);
                                }}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Supplier")}
                                <div className="arrow-down"></div>
                              </Link>
                              <div
                                className={classname("dropdown-menu", {
                                  show: master_Supplier,
                                })}
                              >
                                <Link to="/add_supplier" className="dropdown-item">
                                  {props.t("Add Supplier")}
                                </Link>
                                <Link
                                  to="/supplier-Update"
                                  className="dropdown-item"
                                >
                                  {props.t("View/Update Suppliers")}
                                </Link>
                              </div>
                            </div>
                          )}
                        {role === "Central Store Assistant" && (
                          <div className="dropdown">
                            <Link
                              to="/#"
                              onClick={(e) => {
                                e.preventDefault();
                                setMaster_Supplier(!master_Supplier);
                              }}
                              className="dropdown-item dropdown-toggle arrow-none"
                            >
                              {props.t("Supplier")}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              className={classname("dropdown-menu", {
                                show: master_Supplier,
                              })}
                            >
                              <Link
                                to="/supplier-Update"
                                className="dropdown-item"
                              >
                                {props.t("View/Update Suppliers")}
                              </Link>
                            </div>
                          </div>
                        )}

                        {(role === "admin" ||
                          role === "Central Store Assistant" ||
                          role === "Client Admin" ||
                          role === "Operations Manager") && (
                            <>
                              <div className="dropdown">
                                <Link
                                  to="/#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setUsers(!users);
                                  }}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Users")}
                                  <div className="arrow-down"></div>
                                </Link>
                                <div
                                  className={classname("dropdown-menu", {
                                    show: users,
                                  })}
                                >
                                  <Link
                                    to="/users-adduser"
                                    className="dropdown-item"
                                  >
                                    {props.t("Add User")}
                                  </Link>
                                  <Link
                                    to="/users-updateuser"
                                    className="dropdown-item"
                                  >
                                    {props.t("View/Update Users")}
                                  </Link>
                                </div>
                              </div>
                              {(role === "admin" ||
                                role === "Operations Manager" || 
                                role === "Client Admin" ) && (
                                  <Link to="/app_settings" className="dropdown-item">
                                    {props.t("Settings")}
                                  </Link>
                                )}
                            </>
                          )}
                      </div>
                    </li>
                  )}


                {role === "Branch Supervisor" && (
                  <>
                  {/* Orders */}
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        setBranchOrders(!branchOrders);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="mdi mdi-cart mr-2"></i>
                      {props.t("Orders")}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: branchOrders,
                      })}
                    >
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchOrders_FinishedProducts(
                              !branchOrders_FinishedProducts
                            );
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Finished Products")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchOrders_FinishedProducts,
                          })}
                        >
                          <Link
                            to="/finished_products/add_order"
                            className="dropdown-item"
                          >
                            {props.t("Add New Order")}
                          </Link>
                          <Link
                            to="/finished_products/all_orders"
                            className="dropdown-item"
                          >
                            {props.t("View All Orders")}
                          </Link>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchOrders_Items(!branchOrders_Items);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Items")} <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchOrders_Items,
                          })}
                        >
                          <Link to="/items/add_order" className="dropdown-item">
                            {props.t("Add New Order")}
                          </Link>
                          <Link
                            to="/items/all_orders"
                            className="dropdown-item"
                          >
                            {props.t("View All Orders")}
                          </Link>
                          <Link
                            to="/items/alldrafts"
                            className="dropdown-item"
                          >
                            {props.t("All Draft's")}
                          </Link>
                        </div>
                      </div>

                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setReturnItems(!returnItems);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Return Items")} <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: returnItems,
                          })}
                        >
                          <Link to="/branch/items/return" className="dropdown-item">
                            {props.t("New Return")}
                          </Link>
                          <Link
                            to="/branch/items/allreturn"
                            className="dropdown-item"
                          >
                            {props.t("All Returns")}
                          </Link>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setEquipmentOrders(!equipmentOrders);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Equipments")}{" "}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: equipmentOrders,
                          })}
                        >
                          <Link
                            to="/equipments/add_order"
                            className="dropdown-item"
                          >
                            {props.t("Add New Order")}
                          </Link>
                          <Link
                            to="/equipments/all_orders"
                            className="dropdown-item"
                          >
                            {props.t("View All Orders")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                   {/* Kitchen Inv.*/}
                {role === "Branch Supervisor" && is_store === "false" && (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        setBranchInventory(!branchInventory);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="mdi mdi-cart-plus mr-2"></i>
                      {props.t("Kitchen Inv.")}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: branchInventory,
                      })}
                    >
                      <Link
                        to="/finished_products/view_branch_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Finished Products")}
                      </Link>
                      <Link
                        to="/finished_products/view_branch_inventory_kitchen"
                        className="dropdown-item"
                      >
                        {props.t("Used Finished Products")}
                      </Link>
                      <Link
                        to="/finished_products/expired_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Expired Products")}
                      </Link>
                      <Link
                        to="/finished_products/alltransfers"
                        className="dropdown-item"
                      >
                        {props.t("All Product Transfers")}
                      </Link>
                      <Link
                        to="/items/alltransfers"
                        className="dropdown-item"
                      >
                        {props.t("All Item Transfers")}
                      </Link>
                      <Link
                        to="/items/view_branch_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Items")}
                      </Link>
                      <Link
                        to="/items/view_branch_inventory_kitchen"
                        className="dropdown-item"
                      >
                        {props.t("Used Items")}
                      </Link>
                      <Link
                        to="/items/expired_inventory"
                        className="dropdown-item"
                      >
                        {props.t("Expired Items")}
                      </Link>
                    </div>
                  </li>
                )}
                {/* Kitchen Inv., Store Inv.*/}
                {role === "Branch Supervisor" && is_store === "true" && (
                  <>
                    {/* Kitchen Inv.*/}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setBranchInventory(!branchInventory);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart-plus mr-2"></i>
                        {props.t("Kitch. Inv.")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: branchInventory,
                        })}
                      >
                        <Link
                          to="/finished_products/view_branch_inventory"
                          className="dropdown-item"
                        >
                          {props.t("Finished Products")}
                        </Link>
                        <Link
                          to="/finished_products/alltransfers"
                          className="dropdown-item"
                        >
                          {props.t("All Product Transfers")}
                        </Link>
                        <Link
                          to="/finished_products/view_branch_inventory_kitchen"
                          className="dropdown-item"
                        >
                          {props.t("Used Finished Products")}
                        </Link>
                        <Link
                          to="/finished_products/expired_inventory"
                          className="dropdown-item"
                        >
                          {props.t("Expired Products")}
                        </Link>
                      </div>
                    </li>
                    {/* Store Inv. */}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setBranchInventory(!branchInventory);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart-plus mr-2"></i>
                        {props.t("Store Inv.")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: branchInventory,
                        })}
                      >
                        <Link
                          to="/items/view_branch_inventory_store"
                          className="dropdown-item"
                        >
                          {props.t("Items")}
                        </Link>
                        <Link
                          to="/items/alltransfers"
                          className="dropdown-item"
                        >
                          {props.t("All Transfers")}
                        </Link>
                        <Link
                          to="/items/view_branch_inventory_kitchen"
                          className="dropdown-item"
                        >
                          {props.t("Used Items")}
                        </Link>
                        <Link
                          to="/items/expired_inventory"
                          className="dropdown-item"
                        >
                          {props.t("Expired Items")}
                        </Link>
                      </div>
                    </li>
                  </>
                )}
                  {/* Branch Inv. Transfer */}
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        setBranchTransferInventory(!branchTransferInventory);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="mdi mdi-cart-plus mr-2"></i>
                      {props.t("Branch Inv. Transfer")}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: branchTransferInventory,
                      })}
                    >
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchTransfers_FinishedProducts(
                              !branchTransfers_FinishedProducts
                            );
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Finished Products")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchTransfers_FinishedProducts,
                          })}
                        >
                          {transfer_privilege == "true" && (
                            <Link
                              to="/finished_products/transfer_inventory_by_branch"
                              className="dropdown-item"
                            >
                              {props.t("New Transfer")}
                            </Link>
                          )}
                          <Link
                            to="/finished_products/transfer_inventory"
                            className="dropdown-item"
                          >
                            {props.t("All Transfers")}
                          </Link>
                          {transfer_privilege === "true" && (
                            <Link
                              to="/finished_products/view_all_branch_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Branch Inventory")}
                            </Link>
                          )}
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchTransfers_Items(!branchTransfers_Items);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Items")} <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchTransfers_Items,
                          })}
                        >
                          {transfer_privilege === "true" && (
                            <Link
                              to="/items/transfer_inventory_by_branch"
                              className="dropdown-item"
                            >
                              {props.t("New Transfer")}
                            </Link>
                          )}
                          <Link
                            to="/items/transfer_inventory"
                            className="dropdown-item"
                          >
                            {props.t("All Transfers")}
                          </Link>
                          {transfer_privilege === "true" && (
                            <Link
                              to="/items/view_all_branch_inventory"
                              className="dropdown-item"
                            >
                              {props.t("Branch Inventory")}
                            </Link>
                          )}
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setEquipmentInventory(!equipmentInventory);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Equipments")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: equipmentInventory,
                          })}
                        >
                          <Link
                            to="/branch/equipments_inventory"
                            className="dropdown-item"
                          >
                            {props.t("View Inventory")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* Closing */}
                  <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      setBranchClosing(!branchClosing);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="mdi mdi-cart-plus mr-2"></i>
                    {props.t("Closing")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", {
                      show: branchClosing,
                    })}
                  >
                    <Link
                      to="/closing/finished_products"
                      className="dropdown-item"
                    >
                      {props.t("Finished Products")}
                    </Link>
                    <Link to="/closing/items" className="dropdown-item">
                      {props.t("Items")}
                    </Link>
                  </div>
                </li>
                </>
                )}

                {/* Procure., Inventory, Orders, Transfer */}
                {role === "Main Store Manager" &&
                  store_type == "Main Store" && (
                    <>
                    {/* Procure. */}
                      <li className="nav-item dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setProcurement(!procurement);
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                        >
                          <i className="bx bx-receipt mr-2"></i>
                          {props.t("Procure.")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: procurement,
                          })}
                        >
                          <Link
                            to="/main_store_requisition_request"
                            className="dropdown-item"
                          >
                            {props.t("New PO Request")}
                          </Link>
                          <Link
                            to="/main_store_po_requests"
                            className="dropdown-item"
                          >
                            {props.t("All PO Requests")}
                          </Link>
                          <Link
                            to="/main_store_all_po"
                            className="dropdown-item"
                          >
                            {props.t("All Purchase Orders")}
                          </Link>
                        </div>
                      </li>
                      {/* Inventory */}
                      <li className="nav-item dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setBranchTransferInventory(
                              !branchTransferInventory
                            );
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                        >
                          <i className="mdi mdi-cart-plus mr-2"></i>
                          {props.t("Inventory ")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: branchTransferInventory,
                          })}
                        >
                          <Link to="/items/inventory" className="dropdown-item">
                            {props.t("Item Inventory")}
                          </Link>

                          <Link
                            to="/equipments/mainstore/inventory"
                            className="dropdown-item"
                          >
                            {props.t("Equip. Inventory")}
                          </Link>
                        </div>
                      </li>
                      {/* Orders */}
                      <li className="nav-item dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOrder_For_SM(!order_For_SM);
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                        >
                          <i className="mdi mdi-cart mr-2"></i>
                          {props.t("Orders")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: order_For_SM,
                          })}
                        >
                          <div className="dropdown">
                            <Link
                              to="/#"
                              onClick={(e) => {
                                e.preventDefault();
                                setStore_Item__order(!store_Item_Order);
                              }}
                              className="dropdown-item dropdown-toggle arrow-none"
                            >
                              {props.t("Items")}{" "}
                              <div className="arrow-down"></div>
                            </Link>

                            <div
                              className={classname("dropdown-menu", {
                                show: store_Item_Order,
                              })}
                            >
                              <Link
                                to="/items/add_new_order/from/main"
                                className="dropdown-item"
                              >
                                {props.t("Add New Order")}
                              </Link>
                              <Link
                                to="/items/all_orders/to/main"
                                className="dropdown-item"
                              >
                                {props.t("View All Orders")}
                              </Link>
                            </div>
                          </div>

                          <div className="dropdown">
                            <Link
                              to="/#"
                              onClick={(e) => {
                                e.preventDefault();
                                setEquipmentOrders(!equipmentOrders);
                              }}
                              className="dropdown-item dropdown-toggle arrow-none"
                            >
                              {props.t("Equipments")}{" "}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              className={classname("dropdown-menu", {
                                show: equipmentOrders,
                              })}
                            >
                              <Link
                                to="/equipments/add_orders/mainstore"
                                className="dropdown-item"
                              >
                                {props.t("Add New Order")}
                              </Link>
                              <Link
                                to="/equipments/all_orders/mainstore"
                                className="dropdown-item"
                              >
                                {props.t("View All Orders")}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                      {/* Transfer */}
                      <li className="nav-item dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setTransferItems(!transferItems);
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                        >
                          <i className="mdi mdi-swap-horizontal mr-2"></i>
                          {props.t("Transfer")}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: transferItems,
                          })}
                        >
                          <Link
                            to="/items/transfer/from/main"
                            className="dropdown-item"
                          >
                            {props.t("Item Transfer")}
                          </Link>
                          <Link
                            to="/items/alltransfers"
                            className="dropdown-item"
                          >
                            {props.t("All Transfers")}
                          </Link>
                          <Link
                            to="/items/allItemRequests/to_main"
                            className="dropdown-item"
                          >
                            {props.t("All Requests")}
                          </Link>
                        </div>
                      </li>
                    </>
                  )}

                {/* Procure., Inventory, Orders , Transfer*/}
                {role === "Sub Store Manager" && store_type == "Sub Store" && (
                  <>
                    {/* Procure. */}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setProcurement(!procurement);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="bx bx-receipt mr-2"></i>
                        {props.t("Procure.")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: procurement,
                        })}
                      >
                        <Link
                          to="/sub_store_requisition_request"
                          className="dropdown-item"
                        >
                          {props.t("New PO Request")}
                        </Link>
                        <Link
                          to="/sub_store_po_requests"
                          className="dropdown-item"
                        >
                          {props.t("All PO Requests")}
                        </Link>
                        <Link to="/substore_all_po" className="dropdown-item">
                          {props.t("All Purchase Orders")}
                        </Link>
                      </div>
                    </li>
                    {/* Inventory */}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setBranchInventory(!branchInventory);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart-plus mr-2"></i>
                        {props.t(" Inventory")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: branchInventory,
                        })}
                      >
                        <Link
                          to="/items/substore/inventory"
                          className="dropdown-item"
                        >
                          {props.t("Item inventory")}
                        </Link>

                        <Link
                          to="/equipments/substore/inventory"
                          className="dropdown-item"
                        >
                          {props.t("Equip. Inventory")}
                        </Link>
                      </div>
                    </li>
                    {/* Orders*/}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setProcurement(!procurement);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-cart mr-2"></i>
                        {props.t("Orders")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: procurement,
                        })}
                      >
                        <Link
                          to="/items/ordered/by/branch"
                          className="dropdown-item"
                        >
                          {props.t("Branch Orders")}
                        </Link>
                        <Link
                          to="/substore/deficit_orders"
                          className="dropdown-item"
                        >
                          {props.t("Deficit Orders")}
                        </Link>

                        {/* <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={(e) => {
                            e.preventDefault();
                            setEquipmentOrders(!equipmentOrders);
                          }}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Branch Orders")} <div className="arrow-down"></div>
                        </Link>
                        <div
                          className={classname("dropdown-menu", {
                            show: equipmentOrders,
                          })}
                        >
                           <Link
                            to="/items/ordered/by/branch"
                            className="dropdown-item"
                          >
                            {props.t("Orders in Process")}
                          </Link>
                          <Link
                            to="/substore/deficit_orders"
                            className="dropdown-item"
                          >
                            {props.t("View All Orders")}
                          </Link>
                        </div>
                        </div> */}
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setStore_Item__order(!store_Item_Order);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Items")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: store_Item_Order,
                            })}
                          >
                            <Link
                              to="/items/add_new_order"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>
                            <Link
                              to="/items/all_orders"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setReturnItems(!returnItems);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Return Items")} <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: returnItems,
                            })}
                          >
                            <Link to="/substore/items/return" className="dropdown-item">
                              {props.t("New Return")}
                            </Link>
                            <Link
                              to="/substore/items/allreturn"
                              className="dropdown-item"
                            >
                              {props.t("All Returns")}
                            </Link>
                          </div>
                        </div>
                        <div className="dropdown">
                          <Link
                            to="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              setEquipmentOrders(!equipmentOrders);
                            }}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Equipments")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: equipmentOrders,
                            })}
                          >
                            <Link
                              to="/equipments/add_orders/substore"
                              className="dropdown-item"
                            >
                              {props.t("Add New Order")}
                            </Link>
                            <Link
                              to="/equipments/all_orders/substore"
                              className="dropdown-item"
                            >
                              {props.t("View All Orders")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* Transfer */}
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setOrder_For_SM(!order_For_SM);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="mdi mdi-swap-horizontal mr-2"></i>
                        {props.t("Transfer")}

                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: order_For_SM,
                        })}
                      >
                        <Link
                          to="/substore/direct_transfer"
                          className="dropdown-item"
                        >
                          {props.t("To Central")}
                        </Link>
                        <Link
                          to="/items/alltransfers"
                          className="dropdown-item"
                        >
                          {props.t("All Transfers")}
                        </Link>
                        <Link
                          to="/items/allItemRequests/to_substore"
                          className="dropdown-item"
                        >
                          {props.t("All Requests")}
                        </Link>
                      </div>
                    </li>
                  </>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(Navbar))
);
